module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department12-6651e8a8a3c854d3e73f730b01753cbe.jpg";